<div class="t-widget" [class.borderless]="fromRX">
  <div class="header">
    <ng-container *ngIf="allowEditWaybillStage && editMode; else titleTemplate">
      <ng-container *ngTemplateOutlet="waybillStageButtons"></ng-container>
    </ng-container>
    <ng-template #titleTemplate>
      <h3 class="t-widgetTitle">
        {{ "translate.order.orderRows" | translate }}
      </h3>
    </ng-template>

    <ng-container *ngIf="allowEdit">
      <div class="edit-controls t-widgetTitle">
        <button class="btn-add" (click)="addLine()"></button>

        <button
          *ngIf="editMode"
          class="btn-delete"
          (click)="onDelete()"
          [disabled]="checkedRows.length == 0"
        ></button>

        <button
          *ngIf="!editMode"
          class="btn-editUser"
          (click)="toggleEdit(true)"
        ></button>
      </div>
    </ng-container>

    <ng-container *ngIf="displayClosedOrder">
      <div class="t-badge bg-warn">
        {{ "translate.order.closed" | translate }}
      </div>
    </ng-container>
  </div>

  <hr />

  <ui-table
    *ngIf="displayedOrderLines && displayedOrderLines.length > 0"
    [isWrapped]="false"
    [data]="displayedOrderLines"
    [dense]="true"
    [rowHover]="false"
    [showPaginator]="false"
    [checkRows]="editMode"
    [templates]="qcModeSw
      ? [
          { title: 'translate.general.odsItem', template: item },
          { title: 'translate.general.odsItemDescr', template: itemDescr },
          { title: 'translate.general.teethListOrig', template: teeth },
          { title: 'translate.general.odsQty', template: qty, colClass: 'cell-100' },
          { title: 'translate.general.discount', template: lineDiscount, colClass: 'cell-100' },
          { title: 'translate.general.total', template: lineTotal, colClass: 'cell-100' },
          { template: newLine }
        ]
      : [
          { title: 'translate.general.odsItem', template: item },
          { title: 'translate.general.odsItemDescr', template: itemDescr },
          { title: 'translate.general.teethListOrig', template: teeth },
          { title: 'translate.general.odsQty', template: qty, colClass: 'cell-100' },
          { template: newLine }
        ]"
  ></ui-table>

  <ng-template #item let-row="row">
    <ng-container *ngIf="isRowEditable(row)">
      <input-wrap cssClass="l-cell-spread">
        <input
          id="inputItemCode_{{ row.seq }}"
          type="text"
          [(ngModel)]="row.itemCode"
          class="t-input t-input--colored"
          (keyup)="onItemCodeEdit(row, $event)"
        />
      </input-wrap>
    </ng-container>

    <ng-container *ngIf="!isRowEditable(row)">
      {{ row.itemCode }}
    </ng-container>
  </ng-template>

  <ng-template #itemDescr let-row="row">
    <ng-container *ngIf="isRowEditable(row)">
      <input-wrap
        cssClass="l-cell-spread"
        [loading]="items && items.loading"
        [required]="true"
      >
        <p-select
          id="inputItemDescr_{{ row.seq }}"
          class="t-input--colored"
          [options]="items"
          [(ngModel)]="row.item"
          [placeholder]="'translate.general.chooseItem' | translate"
          [optionLabel]="'label'"
          [filter]="true"
          [filterBy]="'text,id'"
          appendTo="body"
          (ngModelChange)="row.itemCode = row.item?.id"
        >
        </p-select>
      </input-wrap>
    </ng-container>

    <ng-container *ngIf="!isRowEditable(row)">
      {{ row.item?.text }}
    </ng-container>
  </ng-template>

  <ng-template #teeth let-row="row">
    <ng-container *ngIf="isRowEditable(row)">
      <input-wrap cssClass="l-cell-spread">
        <input
          id="inputTeeth_{{ row.seq }}"
          type="text"
          [(ngModel)]="row.teethList"
          class="t-input t-input--colored teeth"
          [class.invalid]="!row.teethValidation"
          (keypress)="onTeethKeyPress(row, $event)"
          (keyup)="onTeethEdit(row, $event)"
          pTooltip="{{ row.teethValidationMsg }}"
          tooltipPosition="top"
        /> </input-wrap
    ></ng-container>
    <ng-container *ngIf="!isRowEditable(row)">
      {{ row.teethList }}
    </ng-container>
  </ng-template>

  <ng-template #qty let-row="row">
    <ng-container *ngIf="isRowEditable(row)">
      <input-wrap [required]="true">
        <input
          id="inputQty_{{ row.seq }}"
          type="number"
          [(ngModel)]="row.qty"
          class="t-input t-input--colored"
          (keypress)="onQtyEdit(row, $event)"
        />
      </input-wrap>
    </ng-container>
    <ng-container *ngIf="!isRowEditable(row)">
      <span class="qty"> {{ row.qty }} </span>
    </ng-container>
  </ng-template>

  <ng-template #lineDiscount let-row="row">
    <span class="qty">{{ row.lineDiscount }}%</span>
  </ng-template>

  <ng-template #lineTotal let-row="row">
    <span class="qty">{{ row.lineTotal }}</span>
  </ng-template>

  <ng-template #newLine let-row="row">
    <span *ngIf="row.newLineSw" class="stage-circle"></span>
  </ng-template>

  <ng-template #waybillStageButtons>
    <div class="t-buttonSet">
      <button
        *ngFor="let stage of currentOrder?.qcStageOptions"
        class="t-button-outline"
        [class.c-c1]="!stage.primarySw"
        [disabled]="!stage.enabledSw"
        (click)="onWaybillStageChange(stage)"
      >
        {{ stage.text }}
      </button>
    </div>
  </ng-template>

  <ng-container>
    <div class="edit-footer" *ngIf="editMode || newLines.length > 0 || fromRX">
      <div class="t-buttonSet">
        <button
          [class.hidden]="!(editMode || newLines.length > 0)"
          (click)="cancel()"
          class="t-button-outline warn"
          [disabled]="saving"
        >
          {{ "translate.general.cancelChanges" | translate }}
        </button>

        <button
          *ngIf="editMode || newLines.length > 0 || fromRX"
          (click)="save()"
          class="t-button--success"
          [disabled]="saving || !saveEnabled()"
        >
          {{ "translate.general.finish" | translate }}
        </button>
      </div>
    </div></ng-container
  >
</div>
